import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { register } from '../services/authService';
import Logo from '../components/images/logo.png'

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await register(email, password);
      alert('Registered! Now log in.');
      navigate('/login');
    } catch (err) {
      console.error(err);
      alert('Registration failed');
    }
  };

  return (
    <div className='page-container'>
      <div className='wrapper'>
        <div className='form-wrapper animated fadeInUp'>
          <div className='form-wrapper-inner text-center'>
            <div className='form-title'>
              <img src={ Logo } alt="Learning Aids" />
              <h2>Register</h2>
            </div>
            <form onSubmit={handleRegister}>
              <div className='form-field'>
                <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required className='input-text' />
              </div>
              <div className='form-field'>
                <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required className='input-text' />
              </div>
              <div className='form-field-submit'>
                <button type="submit">Register</button>
              </div>
              <hr/>
              <p className="text-muted">Already have an account? <a href="/login"> Log In here</a></p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
